import { render, staticRenderFns } from "./tab_monitoring.vue?vue&type=template&id=40c6f0f2&scoped=true&"
import script from "./tab_monitoring.vue?vue&type=script&lang=js&"
export * from "./tab_monitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6f0f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c6f0f2')) {
      api.createRecord('40c6f0f2', component.options)
    } else {
      api.reload('40c6f0f2', component.options)
    }
    module.hot.accept("./tab_monitoring.vue?vue&type=template&id=40c6f0f2&scoped=true&", function () {
      api.rerender('40c6f0f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/monitoring/tab_monitoring.vue"
export default component.exports